import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-custom-search-box',
    templateUrl: './custom-search-box.component.html',
    styleUrl: './custom-search-box.component.scss',
    standalone: false
})
export class CustomSearchBoxComponent {
  searchTerm: string = ''; // Store the search term

  @Output() searchChange = new EventEmitter<string>(); // Emit the search term

  onSearchChange() {
    this.searchChange.emit(this.searchTerm); // Emit whenever input changes
  }
}
